import {from, Observable, of} from 'rxjs';
import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot} from '@angular/router';
import {UserProfileService} from '@shared/services/api/user-profile.service';

export const AuthGuard: CanActivateFn = (_: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> => {
  const userProfileService = inject(UserProfileService);
  if (!userProfileService.getLoggedInUser()) {
    return from(userProfileService.login(state.url).then(() => {
      return false;
    }, (error) => {
      throw error;
    }));
  } else {
    return of(true);
  }
};
